export default __webpack_public_path__ + "locales/uk-UA/SalesDepartmentRequestDialog.json?hash=5b6a64f32bd0591491fb56844cdf3ead";